import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';
import { createRoutes } from '@/utils/router-helper';

import OauthSignupPage from '@/pages/oauth/OauthSignupPage.vue';
import OauthTriggerPage from '@/pages/oauth/OauthTriggerPage.vue';
import OauthCallbackPage from '@/pages/oauth/OauthCallbackPage.vue';
import OauthPlaidRedirectPage from '@/pages/oauth/OauthPlaidRedirectPage.vue';

export default createRoutes(
  {
    path: '/oauth-trigger',
    name: RouteNames.OAUTH.TRIGGER,
    component: OauthTriggerPage, // Redirected here from Shopify App store when installing our Shopify Native app
  },
  {
    path: '/oauth-signup',
    name: RouteNames.OAUTH.SIGNUP,
    component: OauthSignupPage, // Redirected here with authorization code from Shopify when installing our Shopify Native app
    beforeEnter: authGuard,
  },
  // oauth redirects to this page > calls parent window js + closes
  // Used to connect external accounts
  {
    path: '/oauth-callback',
    name: RouteNames.OAUTH.CALLBACK,
    component: OauthCallbackPage,
    beforeEnter: authGuard,
  },
  {
    path: '/plaid-oauth-callback',
    name: RouteNames.OAUTH.PLAID_CALLBACK,
    component: OauthPlaidRedirectPage,
  },
);
